class FormDecor {
    load_form(i=-1) {
        if (!this.btn_add.hasClass('load')) {
            this.btn_add.formbutton('start');
            this.i = i;
            let data = {
                act: 'load_form',
                from_h: sadd.find('select[name="from_h"]').val(),
                to_h: sadd.find('select[name="to_h"]').val(),
                studio_id: sadd.find('select[name="studio_id"]').val()
            };
            if (i >= 0) {
                data.item = $.toJSON(this.has[i]);
            }
            $.post('/ajax/decor/load_form', data, (r) => {
                let a = jQuery.parseJSON(r);
                this.btn_add.formbutton('stop');
                show_window('form_decor');
                this.wnd.find('.icontent').html(a['html']);
                this.wnd.find('.decor').each((index, element) => {
                    if ($(element).find('.result_price span').html() === '') {
                        this.set_price_wnd($(element));
                    }
                });
            });
        }
    }
    calc_price(decor_id, from, to) {
        let price = 0;
        if ((from>=0)&&(to>=0)) {
            if (from >= to) to += 24;
            let hour = to - from;
            let price_type;
            if (hour <= 3) {
                price_type = 3;
            } else if (hour <= 6) {
                price_type = 6;
            } else { // if (hour <= 11)
                price_type = 11;
            }
            if ((this.prices[decor_id]) && (this.prices[decor_id]['cost_in_' + price_type]>0)) {
                price = this.prices[decor_id]['cost_in_' + price_type];
            } else {
                price = this.el.data('items')[decor_id]['cost_in_' + price_type];
            }
        } else {
            price = 0;
        }
        return price;
    }
    recalc() {
        $.each(this.has, (i,val)=>{
            this.has[i]['price'] = this.calc_price(val['decor_id'], val['from_h'], val['to_h']);
            this.add(i);
        });
        this.refresh_sum(false);
    }
    set_price_wnd(item) {
        let from = parseInt(item.find('.time_from').val());
        let to = parseInt(item.find('.time_to').val());
        let price = this.calc_price(item.data('id'), from, to);
        if (price>0) {
            item.data('price', price)
                .find('.result_price').show()
                .find('span').html(Math.round(price) + ' <i class="fa fa-rub" aria-hidden="true"></i>');
        } else {
            item.data('price', 0);
            item.find('.result_price').hide();
        }
    }
    save(item, btn, error) {
        if (!btn.hasClass('load')) {
            btn.formbutton('start');
            let i;
            let from = item.find('.time_from').val();
            let to = item.find('.time_to').val();
            let arr = {
                status: 'ok'
            };
            let has = Object.assign([], this.has);
            if (this.i === -1) {
                i = has.length;
                has[i] = {};
                has[i].decor_id = item.data('id');
            } else {
                i = this.i;
            }
            has[i].from_h = from;
            has[i].to_h = to;
            has[i].price = item.data('price');
            error.html('');

            if (from<0) {
                arr.status='error';
                arr.message = 'Выберите время начала';
            }
            if (to<0) {
                arr.status='error';
                arr.message = 'Выберите время конца';
            }
            if (arr.status==='ok') {
                $.post('/ajax/decor/check', {
                    date: sadd.find('input[name="date"]').val(),
                    has: $.toJSON(has),
                    i: i
                }, (r) => {
                    let rez = jQuery.parseJSON(r);
                    if (rez['status'] === 'ok') {
                        this.has = has;
                        this.el.find('input[name="decor"]').val($.toJSON(this.has));
                        this.add(i);
                        close_windows();
                        this.refresh_sum(true);
                    } else {
                        error.html(rez['message']);
                    }
                    btn.formbutton('stop');
                });
            } else {
                error.html(arr.message);
                btn.formbutton('stop');
            }
        }
    }
    add(i) {
        let item = this.place.find('.item:eq('+i+')');
        if (item.length===0) {
            this.place.append('<div class="item"></div>');
            item = this.place.find('.item:last');
        }
        let from_h = (this.has[i].from_h<10 ? '0' : '')+this.has[i].from_h;
        let to_h = (this.has[i].to_h<10 ? '0' : '')+this.has[i].to_h;
        let html = `${from_h}:00 - ${to_h}:00 ${this.el.data('items')[this.has[i].decor_id].title} ${this.has[i].price} <i class="fa fa-rub" aria-hidden="true"></i>`;
        item.html(html);
    }
    del(i) {
        let item = this.place.find('.item:eq('+i+')');
        item.remove();
        this.has.splice(i, 1);
    }
    refresh_sum(calc_itog=false) {
        this.sum = 0;
        for (let v of this.has) {
            this.sum += parseFloat(v['price']);
        }
        if (this.has.length>0) {
            this.chb.prop('checked', true);
            this.btn_add.show();
        } else {
            this.chb.prop('checked', false);
            this.btn_add.hide();
        }
        if (calc_itog)
            get_itog();
    }
    add_has() {
        if (this.has.length>0) {
            this.chb.prop('checked', true);
            this.place.show();
            this.btn_add.show();
            for (let i in this.has) {
                this.add(i);
            }
            this.refresh_sum(false);
            get_itog();
        } else {
            this.chb.prop('checked', false);
        }
    }
    disable() {
        this.el.hide();
        this.active = this.chb.prop('checked');
        this.chb.prop('checked', false);
    }
    enable() {
        this.el.show();
        this.chb.prop('checked', this.active);
    }

    constructor(el) {
        this.el = el;
        this.prices = {};
        this.chb = el.find('input[name="decor_chb"]');
        this.place = el.find('.place');
        this.sum = 0;
        this.wnd = el.find('.window[rel="form_decor"]');
        this.btn_add = el.find('.add_decor');
        this.has =  jQuery.parseJSON(el.find('input[name="decor"]').val());
        this.active = (this.has.length>0);
        this.i = -1;
        this.add_has();

        this.btn_add.on('click', ()=>{
            this.load_form();
        });
        this.place.on('click', '.item', (event)=>{
            this.load_form($(event.currentTarget).index());
        });
        this.wnd.on('click', '.change_decor', (event)=>{
            let btn = $(event.currentTarget);
            let item = btn.closest('.decor');
            this.save(item, btn,  item.find('.error'));
        });
        this.wnd.on('change', '.time_from, .time_to', (event)=>{
            let item = $(event.currentTarget).closest('.decor');
            this.set_price_wnd(item);
        });
        this.wnd.on('click', '.save', (event)=>{
            let item = this.wnd.find('.decor');
            this.save(item, $(event.currentTarget), this.wnd.find('.error'));
        });

        this.chb.on('change', (event)=>{
            if ($(event.currentTarget).prop('checked')) {
                this.place.show();
                this.btn_add.show();
                if (this.has.length===0)
                    this.load_form();
            } else {
                this.place.hide();
                this.btn_add.hide();
            }
        });
        this.wnd.on('click', '.del', (event)=>{
            this.del(this.i);
            close_windows();
            this.refresh_sum(true);
        });
    }
}
let form_decor;
$(function(){
    form_decor = new FormDecor(sadd.find('.form_decor'));
});